@if (project) {
  @if (!!project) {
    <colimo-project-header [project]="project" [lineId]="lineId" [modelId]="modelId"
      (productSelectionEvent)="productSelectionChanged($event)" [showProductSelection]="true"
      (batchStateUpdateEvent)="onBatchStateUpdated($event)" [showProductCCNGUpdate]="true">
    </colimo-project-header>
  }
  <colimo-modal [size]="'md'"></colimo-modal>
  <div class="batch-page-wrapper flex-column gap-15 gap-lt-sm-0">
    <div class="container">
      <h2 class="dashboard-headline">{{ 'dashboard.charge' | translate }}</h2>
    </div>
    @if (project.batches) {
      <div class="container flex-column gap-20">
        @for (productBatch of displayBatches; track i; let i = $index) {
          <div>
            <colimo-project-batch
              id="{{ productBatch.batchId }}"
              [project]="project"
              [batch]="productBatch"
              [modelId]="modelId"
              [projectPage]="currentPage"
              [isColorRoute]="isColorRoute"
              [batchLineSelections]="batchLineSelections"
              [showVectorButton]="showVectorButton"
              >
            </colimo-project-batch>
          </div>
        }
      </div>
    }
    @if (batchesLoaded && !project.batches) {
      <div class="background-well project-empty">
        <div class="empty-text">{{ 'dashboard.noBatches' | translate }}</div>
      </div>
    }
    @if (!isLastPage) {
      <div class="container">
        <button (click)="loadMore()" class="btn btn-link" [disabled]="!moreBatchesLoaded">
          {{ 'dashboard.more' | translate }}
          <colimo-icons
            [icon]="'arrow-small'"
            [width]="'18px'"
            [height]="'11px'"
            [top]="'1px'"
            [direction]="'right'"
          ></colimo-icons>
        </button>
        @if (!moreBatchesLoaded) {
          <colimo-loader [background]="'transparent'" [isRelative]="true"></colimo-loader>
        }
      </div>
    }
  </div>
}

@if (!batchesLoaded) {
  <colimo-loader [background]="'transparent'" [top]="'50%'"></colimo-loader>
}
